import { render } from "./BankCardManage.vue?vue&type=template&id=3a8e4082&scoped=true"
import script from "./BankCardManage.vue?vue&type=script&lang=js"
export * from "./BankCardManage.vue?vue&type=script&lang=js"

import "./BankCardManage.vue?vue&type=style&index=0&id=3a8e4082&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8e4082"]])

export default __exports__